import { useRef, useState } from "react";
import { EmailMobile, Message, Password, Pin, SignInTitle, SubmitClearButton } from "./LoginUtil";
import { encrypt, handleInput, handleReset } from "../Common/Util";
import { validateEmailMobile, validatePassword, validatePin } from "./LoginValidate";
import { axiosErrorHandler, axiosPost } from "../Common/axios";
import { Link, useNavigate } from "react-router-dom";

export function Signin() {
    const navigate = useNavigate();

    const [message, setMessage] = useState(null);
    const [page, setPage] = useState("");

    const [email, setEmail] = useState("");
    const [pin, setPin] = useState("");
    const [password, setPassword] = useState("");
    const setMethod = { setEmail, setPin, setPassword, setMessage };

    const emailReference = useRef();
    const pinReference = useRef();
    const passwordReference = useRef();


    function handleSubmit(event) {
        var msg = '';
        if(msg==='') msg = validateEmailMobile(event,emailReference,email);
        if(msg==='') {
            if(page==='') {
                msg = validatePin(event, pinReference,pin);
            } else if(page==='1') { 
                msg = validatePassword(event, passwordReference, password);
            }
        }
        if(msg==='') {
            const data = {
                emailOrMobile: email,
                pin: ''+encrypt(pin),
                password: ''+encrypt(password),
            }
            axiosPost("/astrologer/login", data,
                (response)=>{
                    //alert(response.data.code+' '+response.data.message);
                    if(response.data.code==='200') { //success
                        msg="";
                        localStorage.setItem("token", response.data.token);
                        setTimeout(() => {
                            navigate('/home.html', { state:{}, replace: true });
                            navigate(0);
                          }, 100);
                    } else if(response.data.code==='101' ) { //invalid login credential
                        setPage('');
                        handleReset(setMethod,emailReference);
                        setMessage(response.data.message);
                    } else if(page==='') { 
                        if(response.data.code==='103' //invalid password 
                            || (response.data.code==='102'&& response.data.pinCount>= 3) ) { //invalid pin exceeds count
                            handleReset(setMethod,emailReference);
                            setPage("1");
                            setMessage('Pin is blocked. Try after 30 mins or try with password');
                        } else if(response.data.code==='102' ) { //invalid pin
                            setMessage(response.data.message+". "+(3-response.data.pinCount)+" attempts pending");
                            pinReference.current.focus();
                        } else { //other errors
                            setMessage(response.data.message);
                            pinReference.current.focus();
                        }

                    } else if(page==='1') { 
                        if(response.data.code==='102'&& response.data.pinCount< 3) { //invalid pin less than count
                            setPage("");
                            setMessage('Invalid option. Try with pin');
                            emailReference.current.focus();
                        } else if(response.data.code==='102'&& response.data.pinCount>= 3) { //invalid pin less than count
                            setPage("");
                            setMessage("Invalid password. "+(3-response.data.pinCount)+" attempts pending");
                            pinReference.current.focus();
                        } else if(response.data.code==='103' && response.data.passwordCount>=3) { //invalid password
                            setPage("");
                            handleReset(setMethod,emailReference);
                            setMessage(response.data.message+". Account is locked.");
                        } else if(response.data.code==='103' ) { //invalid password
                            setMessage(response.data.message+". "+(3-response.data.passwordCount)+" attempts pending");
                            passwordReference.current.focus();
                        } else { //other errors
                            setMessage(response.data.message);
                            passwordReference.current.focus();
                        }

                    } else {
                        setPage('');
                        handleReset(setMethod,emailReference);
                        setMessage(response.data.message);
                    }
                    setPin("");
                    setPassword("");
                },
                (error)=>{
                    setMessage(axiosErrorHandler(emailReference,error));
                    setPin("");
                    setPassword("");
                }
            );
        }
        event.preventDefault();
    }

    return (
        <>
            <div class="container text-start">
                <SignInTitle title="Sign In" name="Sign Up" url="signup.html"/>
                <Message msg={message} />
                { page!=='1'?
                    <form method="post" onSubmit={handleSubmit}>
                        <EmailMobile reference={emailReference} data={email} callback={(event)=>handleInput(event,setMethod)}/> 
                        <Pin reference={pinReference} data={pin} callback={(event)=>handleInput(event,setMethod)}/> 
                        <SubmitClearButton callback={()=>handleReset(setMethod,emailReference)}/> 
                    </form>
                :
                    <form method="post" onSubmit={handleSubmit}>
                        <EmailMobile reference={emailReference} data={email} callback={(event)=>handleInput(event,setMethod)}/> 
                        <Password reference={passwordReference} data={password} callback={(event)=>handleInput(event,setMethod)}/> 
                        <SubmitClearButton callback={()=>handleReset(setMethod,emailReference)}/> 
                    </form>
                }
                <ul class="nav justify-content-center">
                    <li class="nav-item">
                    <Link to="/fpin.html" class="nav-link">Forgot Pin</Link>
                    </li>
                    <li class="nav-item">
                    <Link to="/rpass.html" class="nav-link">Reset Password</Link>
                    </li>
                </ul>
            </div>
        </>
    );
}